import gsap from 'gsap'

import {
  buttonRevealAnimation,
  fadeImageAnimation,
  fadeInAnimation,
  SharedAnimation,
  titleRevealAnimation
} from './shared'
import { Animation } from '@/types'

export const textOnImage = ({ node, reverse, context }: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const image = selector('[data-motion-image]')[0]
  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]
  const cta = selector('[data-motion-cta]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let imageAnimation: SharedAnimation
  if (image) {
    imageAnimation = fadeImageAnimation(image)
    timeline.add(imageAnimation.timeline, '<')
  }

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = fadeInAnimation(pretitle)
    timeline.add(pretitleAnimation.timeline, '<+0.5')
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = titleRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<+0.5')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = fadeInAnimation(paragraph)
    timeline.add(paragraphAnimation.timeline, '<+0.5')
  }

  let ctaAnimation: SharedAnimation
  if (cta) {
    ctaAnimation = buttonRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, '<+0.5')
  }

  return () => {
    if (imageAnimation) {
      imageAnimation.revert()
    }
    if (pretitleAnimation) {
      pretitleAnimation.revert()
    }
    if (titleAnimation) {
      titleAnimation.revert()
    }
    if (paragraphAnimation) {
      paragraphAnimation.revert()
    }
    if (ctaAnimation) {
      ctaAnimation.revert()
    }
  }
}
